import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { X } from "@phosphor-icons/react/X";
import { FC, ReactNode } from "react";

export interface MapToolDrawerProps {
	title?: string;
	onClose?: () => void;
	Content: ReactNode;
	Action?: ReactNode;
}

export const MapToolDrawer: FC<MapToolDrawerProps> = ({
	title,
	onClose,
	Content,
	Action,
}) => {
	return (
		<Paper
			sx={{ height: "100dvh", width: "var(--MapTool-width)", borderRadius: 0 }}>
			<Stack height="100%">
				{(!!title || !!onClose) && (
					<Stack
						direction="row"
						alignItems="center"
						p={2}>
						<Typography
							variant="h6"
							flex={1}>
							{title ?? ""}
						</Typography>

						{onClose && (
							<IconButton onClick={onClose}>
								<X />
							</IconButton>
						)}
					</Stack>
				)}
				<Divider />
				<Box
					flex={1}
					sx={{ overflowY: "auto" }}>
					{Content}
				</Box>
				{!!Action && <Box p={2}>{Action}</Box>}
			</Stack>
		</Paper>
	);
};
